import { render, staticRenderFns } from "./screenPage.vue?vue&type=template&id=6d39261e&scoped=true"
import script from "./screenPage.vue?vue&type=script&lang=js"
export * from "./screenPage.vue?vue&type=script&lang=js"
import style0 from "./screenPage.vue?vue&type=style&index=0&id=6d39261e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d39261e",
  null
  
)

export default component.exports